import { useCallback, useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";

import { anularNovedad, novedades } from "../services/puertoNovedades";
import { actual as quienSoy } from "../services/quien";
import BotonConfirmar from "../components/funcionales/BotonConfirmar";
import ModoEdicion from "../components/funcionales/ModoEdicion";
import Loading from "./Loading";

/* Las novedades / inconvenientes del personal del puerto (P-181, Natalia).
 *
 * ── SE CARGAN POR WHATSAPP, ACÁ SÓLO SE MIRAN ──────────────────────────────
 *
 * La gente del puerto las manda con `novedad ...` desde el teléfono —falta de
 * herramientas, clima, algo roto que no es de una unidad—. Un formulario acá
 * sería un segundo lugar para lo mismo. Lo único que se escribe es **anular**.
 *
 * ── ES OTRA COSA QUE LOS TRABAJOS ──────────────────────────────────────────
 *
 * Un trabajo va a la ficha de un camión («774 cambio de pastillas»); una
 * novedad es un problema del turno, sin unidad. Por eso viven en tablas
 * distintas y en pantallas distintas.
 */

const cuando = (iso) => {
  if (!iso) return "";
  const d = new Date(new Date(iso).getTime() - 3 * 3600 * 1000);
  if (Number.isNaN(d.getTime())) return "";
  const p = (n) => String(n).padStart(2, "0");
  return `${p(d.getUTCDate())}/${p(d.getUTCMonth() + 1)} ${p(d.getUTCHours())}:${p(d.getUTCMinutes())}`;
};

const PuertoNovedades = () => {
  const { permisos = null } = useOutletContext() || {};
  const [filas, setFilas] = useState(null);
  const [error, setError] = useState(null);
  const [editando, setEditando] = useState(false);
  const [yendo, setYendo] = useState(null);

  /* Mientras los permisos no llegaron se asume que puede: esconder el lápiz
   * medio segundo y después mostrarlo se lee como que la pantalla titila. */
  const puedeEditar = !permisos || permisos.includes("cargar.puerto");
  const tocando = puedeEditar && editando;

  const traer = useCallback(async () => {
    try {
      setFilas(await novedades());
    } catch (e) {
      setError(e.message || "No se pudieron leer las novedades");
    }
  }, []);

  useEffect(() => {
    traer();
  }, [traer]);

  const anular = async (id) => {
    setYendo(id);
    try {
      await anularNovedad(id, quienSoy()?.mail || null);
      setFilas((prev) => (prev || []).filter((f) => f.id !== id));
    } catch (e) {
      setError(e.message || "No se pudo anular");
    } finally {
      setYendo(null);
    }
  };

  if (error && !filas) {
    return (
      <div className="panel-aviso"><h3>No se pudo consultar</h3></div>
    );
  }
  if (!filas) return <Loading />;

  return (
    <div className="docs">
      <div className="tk-filtros">
        <ModoEdicion
          activo={editando}
          onCambiar={setEditando}
          puede={puedeEditar}
          que="las novedades"
        />
      </div>

      {error && <p className="panel-aviso suave">{error}</p>}

      {filas.length === 0 && (
        <p className="panel-aviso suave">
          Todavía no hay ninguna novedad.
        </p>
      )}

      {filas.length > 0 && (
        <div className="tabla-wrap">
          <table className="tabla fija">
            <thead>
              <tr>
                <th>Qué pasó</th>
                <th>Quién</th>
                <th>Cuándo</th>
                {tocando && <th></th>}
              </tr>
            </thead>
            <tbody>
              {filas.map((f) => (
                <tr key={f.id}>
                  <td style={{ whiteSpace: "pre-wrap" }}>{f.detalle}</td>
                  <td>
                    {f.persona || <span className="sin-dato">sin nombre</span>}
                    {f.rol && <span className="sub">{f.rol}</span>}
                  </td>
                  <td className="tenue">{cuando(f.creado_en)}</td>
                  {tocando && (
                    <td>
                      {/* PREGUNTA ANTES. Desde acá un anulado no se puede
                          volver a traer, y el botón está a un dedo de la
                          fila de al lado. */}
                      <BotonConfirmar
                        className="link-button"
                        disabled={yendo === f.id}
                        pregunta="¿Anular?"
                        si="Sí, anular"
                        onConfirmar={() => anular(f.id)}
                      >
                        {yendo === f.id ? "Anulando…" : "Anular"}
                      </BotonConfirmar>
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <p className="docs-pie">
        Se cargan por WhatsApp: <code>novedad</code> y qué pasó.
      </p>
    </div>
  );
};

export default PuertoNovedades;
